import React from 'react';
import STCIcon from 'src/components/10-atoms/icons/STCIcon';
import { RootTab } from 'src/navigation/TabNavigation';
import withSuspense from 'src/navigation/withSuspense';
const Home = withSuspense(React.lazy(() => import('./screens/Home')));
export const renderSTCTabRoutes = ({ translate }) => {
    return (React.createElement(RootTab.Group, null,
        React.createElement(RootTab.Screen, { name: "STC_Home", options: {
                tabBarLabel: translate('Support Us'),
                tabBarIcon: STCIcon,
            }, component: Home })));
};
